import { useState, useEffect, useCallback } from 'react';

interface Props {
  deadlineAt: Date;
  onExpired:  () => void;
}

export function CountdownTimer({ deadlineAt, onExpired }: Props) {
  const getRemaining = useCallback(() => Math.max(0, deadlineAt.getTime() - Date.now()), [deadlineAt]);
  const [remaining, setRemaining] = useState(getRemaining);

  useEffect(() => {
    if (remaining <= 0) { onExpired(); return; }
    const id = setInterval(() => {
      const r = getRemaining();
      setRemaining(r);
      if (r === 0) { clearInterval(id); onExpired(); }
    }, 1000);
    return () => clearInterval(id);
  }, [deadlineAt, getRemaining, onExpired, remaining]);

  const totalSec = Math.floor(remaining / 1000);
  const mins     = Math.floor(totalSec / 60).toString().padStart(2, '0');
  const secs     = (totalSec % 60).toString().padStart(2, '0');
  const color    =
    totalSec < 60  ? 'text-red-400'   :
    totalSec < 300 ? 'text-amber-400' :
    'text-white/60';

  return <span className={`font-mono text-sm font-bold ${color}`}>{mins}:{secs}</span>;
}
